import React from 'react';
import config from 'config';
import { user } from 'core';
import { useLocation } from 'react-router-dom';
import { settings, utilities } from 'core/use-cases';

import type { MountFunction, OnParentNavigationFunction, UseMicrofrontend } from './types';
import { getAccessToken } from 'core/services/auth';

export const useMicrofrontend = (mount: MountFunction, document?: string): UseMicrofrontend => {
  const location = useLocation();
  const { history } = utilities;
  const appToken = getAccessToken() || '';
  const { data: reseller } = user.hooks.useUser();
  const homePath = settings.hooks.useHomepage();
  const onParentNavigationRef = React.useRef<OnParentNavigationFunction>();
  const mfElementRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (mfElementRef.current) {
      const { onParentNavigation } = mount(mfElementRef.current, {
        appToken,
        brand: {
          short: config.app.slugname,
          sac: {
            whatsapp: config.renegotiationSac.whatsapp,
            phone: config.renegotiationSac.phone,
            portalName: config.renegotiationSac.portalName,
            portalLink: config.renegotiationSac.portalLink,
            hours: {
              whatsapp: config.renegotiationSac.hours.whatsapp,
              phone: config.renegotiationSac.hours.phone,
              portal: config.renegotiationSac.hours.portal,
            },
          },
        },
        defaultHistory: history,
        fallbackUrl: config.app.fallbackUrl,
        homePath,
        reseller,
        document,
      });

      onParentNavigationRef.current = onParentNavigation;
    }
  }, []);

  React.useEffect(() => {
    onParentNavigationRef.current && onParentNavigationRef.current(location);
  }, [location]);

  return { mfElementRef };
};
